import { markRFIAsClosed } from "@/api/rfi";
import { Divider } from "@/components/misc";
import { useState, useEffect } from "react";
import { CardDropdownRFI } from "./Utils/CardDropdown";
import { CardBase, DaysOldColor, PingedCardAlert } from "./Utils/CardHelper";
import { NotesSection } from "../ProjectProgress/Utils/NotesSection";
import { CategoryIcon } from "./Utils/CategoryIcon";
import { TitleHeaderHyperlink } from "./Utils/TitleHeaderHyperlink";
import { RFIProps } from "@/interfaces/rfi_types";
import { useNavigate, useLocation } from "react-router-dom";

type RFICardProps = {
    rfi: RFIProps,
    isNew: boolean,
    onView: () => void
}
export function RFICard({ rfi, isNew, onView }: RFICardProps) {
    const [isNewLocal, setIsNewLocal] = useState(isNew)
    const navigate = useNavigate()
    const location = useLocation()

    const handleMark = async () => {
        if (confirm("Are you sure you want to mark this RFI as closed?")) {
            if (rfi.RFI_id) {
                const response = await markRFIAsClosed(rfi.RFI_id);
                if (response.operation === "COMPLETED") {
                    navigate(location.pathname, { replace: true })
                }
            } else {
                alert("RFI ID is not defined")
            }
        }
    }

    useEffect(() => {
        if (isNewLocal) {
            setIsNewLocal(true);
            onView();
        }
    }, [isNewLocal, onView])

    return (
        <CardBase
            isNew={isNewLocal}
            isOverdue={rfi.alert_status ?? false}
            hoverChildren={<CardDropdownRFI
                edit_rfi_route={`/rfi/update_rfi/${rfi.RFI_id}`}
                folder_path={rfi.folder_location ?? ''}
                parent_project_folder_location={rfi.parent_project_folder_location ?? ''}
                mark_as_closed_fn={handleMark} />}
        >
            {rfi.alert_status && <PingedCardAlert text="Please complete this RFI soon. It is overdue." />}
            <div className="flex flex-row items-center">
                <CategoryIcon category={rfi.category} />
                <TitleHeaderHyperlink title={rfi.project_name ?? 'Project Name Not Found'} folder_location={rfi.folder_location ?? ''} />
            </div>

            <Divider />

            <NotesSection notes={rfi.description ?? ''} />

            <div className="flex flex-row justify-between">
                <p>RFI #: {rfi.RFI_number || 'N/A'}</p>
                <p>Days Old: <span className={DaysOldColor(rfi.days_old ?? 0)}>{rfi.days_old}</span></p>
            </div>
        </CardBase>
    );
}
